import { cn } from '@/lib/utils.js';

interface FilterChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
  count?: number;
  className?: string;
}

export function FilterChip({ label, active, onClick, count, className }: FilterChipProps) {
  return (
    <button
      onClick={onClick}
      role="radio"
      aria-checked={active}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-[20px] text-xs font-medium transition-all duration-150',
        'border whitespace-nowrap',
        active
          ? 'bg-[oklch(0.28_0.05_255)] text-white border-[oklch(0.28_0.05_255)]'
          : 'bg-card text-muted-foreground border-border hover:border-[oklch(0.80_0.006_250)] hover:text-foreground',
        className
      )}
    >
      {label}
      {count !== undefined && (
        <span className={cn('font-mono text-[10px] tabular-nums', active ? 'text-white/70' : 'text-muted-foreground')}>
          {count}
        </span>
      )}
    </button>
  );
}

interface FilterChipGroupProps {
  chips: { key: string; label: string; count?: number }[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
}

export function FilterChipGroup({ chips, value, onChange, className }: FilterChipGroupProps) {
  return (
    <div role="radiogroup" className={cn('flex items-center gap-1.5 flex-wrap', className)} aria-label="Filter">
      {chips.map(chip => (
        <FilterChip
          key={chip.key}
          label={chip.label}
          count={chip.count}
          active={value === chip.key}
          onClick={() => onChange(chip.key)}
        />
      ))}
    </div>
  );
}
